import { Dispatch } from 'react'

import { TaskAffecteeInfoFragment, TaskableFragment } from 'generated/resources/graphql'

import {
  PossibleTaskState,
  TaskCustomComponent,
  TaskDefinition,
} from 'modules/inbox_tasks/lib/abstraction'
import { getStateForTaskDefinition, getTaskableForTypename } from 'modules/inbox_tasks/lib/helpers'

type Props = {
  taskDefinition: TaskDefinition
  affectee?: TaskAffecteeInfoFragment
  taskable?: TaskableFragment | null
  taskId: string
  state?: PossibleTaskState
  updateState: Dispatch<PossibleTaskState | undefined>
  dueOn?: string
  assigneesTotalCount?: number
}

function Content({
  taskDefinition,
  affectee,
  taskable,
  taskId,
  state,
  updateState,
  dueOn,
  assigneesTotalCount,
}: Props) {
  const safeTaskable = taskable ? getTaskableForTypename(taskable, taskDefinition) : undefined
  const isStateSafe = getStateForTaskDefinition(state, taskDefinition.initialState)

  if (!taskDefinition?.component || !isStateSafe) {
    return null
  }

  const Component: TaskCustomComponent<never> = taskDefinition.component

  return (
    <Component
      affectee={affectee}
      taskId={taskId}
      taskable={safeTaskable}
      state={state}
      updateState={updateState}
      dueOn={dueOn}
      assigneesTotalCount={assigneesTotalCount}
    />
  )
}

export default Content
